import { BlockSchema } from './Block.types';

import { PagePasswordBlockConfigSchema } from './blockConfig/Types';

import { z } from 'zod';

export enum PagePasswordLayout {
  Standard = 'standard',
}

export const PagePasswordBlockSchema = BlockSchema.extend({
  blockConfig: PagePasswordBlockConfigSchema,
});

export type PagePasswordBlock = z.infer<typeof PagePasswordBlockSchema>;
